import * as React from 'react';



export default class Dashboard extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
       <g id="left-nav-primary-icons" stroke="" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-436.000000, -134.000000)">
			<g id="Group-11" transform="translate(436.000000, 134.000000)" stroke="" strokeWidth="1.5">
				<g id="Group-6" transform="translate(2.000000, 2.000000)">
					<rect id="Rectangle-3-Copy-8" x="0.75" y="0.75" width="18.5" height="18.5" rx="1"></rect>
					<g id="Group" transform="translate(4.090909, 3.636364)" strokeLinecap="square">
						<path d="M1.36363636,7.72727273 L1.36363636,12.2727273" id="Line-3"></path>
						<path d="M5.90909091,0.454545455 L5.90909091,12.2727273" id="Line-3-Copy"></path>
						<path d="M10.4545455,4.09090909 L10.4545455,12.2727273" id="Line-3-Copy-2"></path>
					</g>
				</g>
			</g>
		</g>
      </svg>
    )
  }
}
